// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__RY69Z","large":"styles_large__1F0e0"};